import { LocalStorageConstants } from "../constants/LocalStorageConstants.ts";
import { POSTHOG_EVENTS } from "../constants/PostHogEvents";
import { UserOrganization } from "../models/organization";
import postHogService from "../services/PostHogService";
import iframeStore from "../pages/IframeNew/iframe-store.tsx";

const getSelectedOrgKey = () => {
	return `${iframeStore?.isIframe() ? iframeStore?.iframe?.id + "_" : ""}selected_org`;
};

export const getSelectedOrganization = () => {
	const selectedOrg = localStorage.getItem(getSelectedOrgKey());
	return selectedOrg ? (JSON.parse(selectedOrg) as UserOrganization) : null;
};

export const setSelectedOrganization = (selectedOrg: UserOrganization) => {
	const previousOrg = getSelectedOrganization();
	const result = localStorage.setItem(getSelectedOrgKey(), JSON.stringify(selectedOrg));
	
	// Track organization selection/switch (localStorage helpers don't have user context, so pass null)
	if (previousOrg && previousOrg.organization.uid !== selectedOrg.organization.uid) {
		postHogService.trackEvent(POSTHOG_EVENTS.ORGANIZATION_SWITCHED, {
			from_org: previousOrg.organization.name,
			from_org_id: previousOrg.organization.uid,
			to_org: selectedOrg.organization.name,
			to_org_id: selectedOrg.organization.uid,
			org_role: selectedOrg.role
		}, null);
	} else if (!previousOrg) {
		postHogService.trackEvent(POSTHOG_EVENTS.ORGANIZATION_SELECTED, {
			org_role: selectedOrg.role,
			is_first_selection: true
		}, null);
	}
	
	return result;
};

export const clearSelectedOrganization = () => {
	return localStorage.removeItem(getSelectedOrgKey());
};

export const getAwsRegistrationToken = () => {
	const queryParams = new URLSearchParams(location.search);
	const awsRegistrationToken = queryParams.get(LocalStorageConstants.AWS_REGISTRATION_TOKEN) || undefined;
	if (awsRegistrationToken) {
		localStorage.setItem(LocalStorageConstants.AWS_REGISTRATION_TOKEN, awsRegistrationToken);
	}
	return localStorage.getItem(LocalStorageConstants.AWS_REGISTRATION_TOKEN);
};

export const clearAwsRegistrationToken = () => {
	return localStorage.removeItem(LocalStorageConstants.AWS_REGISTRATION_TOKEN);
};
